// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"48219649","126":"eb9d851a","171":"5a2a852c","378":"edbfbe6a"}[chunkId] + ".chunk.js";
};